import React from 'react';

const hoy = () => new Date(Date.now() - 3 * 3600 * 1000).toISOString().slice(0, 10);
const restar = (dias) => new Date(Date.now() - dias * 86400000 - 3 * 3600 * 1000).toISOString().slice(0, 10);
const inicioDeMes = () => hoy().slice(0, 7) + '-01';

// Presets de período. Devuelve { desde, hasta, preset }
export const PRESETS = {
  semana: { label: 'Última semana', calcular: () => ({ desde: restar(7), hasta: hoy() }) },
  mes: { label: 'Últimos 30 días', calcular: () => ({ desde: restar(30), hasta: hoy() }) },
  actual: { label: 'Mes en curso', calcular: () => ({ desde: inicioDeMes(), hasta: hoy() }) },
  anio: { label: 'Este año', calcular: () => ({ desde: hoy().slice(0, 4) + '-01-01', hasta: hoy() }) },
  doce: { label: 'Últimos 12 meses', calcular: () => ({ desde: restar(365), hasta: hoy() }) },
  /* "Todo" no puede terminar hoy: un cobro que vence la semana que viene es
     parte de todo. Sin tope superior entran también los futuros y los "a pasar",
     que es lo que hace que la pantalla de Cobros sirva como cashflow completo. */
  todo: { label: 'Todo', calcular: () => ({ desde: '2020-01-01', hasta: '' }) },
  custom: { label: 'Personalizado', calcular: () => ({ desde: inicioDeMes(), hasta: hoy() }) },
};

export const rangoInicial = (preset = 'doce') => ({ preset, ...PRESETS[preset].calcular() });

export default function RangoFechas({ valor, onChange, opciones = ['semana', 'mes', 'actual', 'anio', 'doce', 'todo', 'custom'], derecha }) {
  const elegir = (k) => onChange({ preset: k, ...PRESETS[k].calcular() });
  const chip = (a) => ({
    padding: '6px 13px', borderRadius: 999, fontSize: 13, fontWeight: 600, cursor: 'pointer',
    border: '1px solid ' + (a ? 'var(--accent)' : 'var(--border)'),
    background: a ? 'var(--accent)' : 'transparent', color: a ? '#fff' : 'var(--text-secondary)',
  });

  return (
    <div className="card" style={{ marginBottom: 16, padding: '12px 14px', display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
      {opciones.map(k => <div key={k} style={chip(valor.preset === k)} onClick={() => elegir(k)}>{PRESETS[k].label}</div>)}
      {valor.preset === 'custom' && (
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <input type="date" value={valor.desde} max={valor.hasta} onChange={e => onChange({ ...valor, desde: e.target.value })} style={{ width: 'auto', fontSize: 13 }} />
          <span style={{ color: 'var(--text-muted)', fontSize: 13 }}>a</span>
          <input type="date" value={valor.hasta} min={valor.desde} onChange={e => onChange({ ...valor, hasta: e.target.value })} style={{ width: 'auto', fontSize: 13 }} />
        </div>
      )}
      {derecha && <div style={{ marginLeft: 'auto' }}>{derecha}</div>}
    </div>
  );
}
